module.exports = __webpack_public_path__ + "static/media/timesSquare.d2f97b90.jpg";